// @flow
import * as React from 'react'
import styled, { css } from 'styled-components'
import Theme from 'ui/theme'

type Props = {
  visibleOnHover?: boolean,
  active?: boolean,
}

const StyledBlueLineContainer = styled.div`
  padding-top: ${Theme.spacing.xsmall};
  padding-bottom: ${Theme.spacing.xsmall};
  ${({ visibleOnHover }: Props) =>
    visibleOnHover
      ? css`
          & > * {
            opacity: 0;
          }
          &:hover > div {
            opacity: 1;
          }
        `
      : css``};
`

const StyledBlueLine = styled.div`
  background: blue;
  height: ${Theme.spacing.xsmall};
  border-radius: ${Theme.borderRadius.small};
  background-color: ${Theme.color.borderPrimary};
  transition: opacity 150ms;

  ${({ active }: Props) =>
    active
      ? css`
          opacity: 1;
        `
      : css``}
`

const BlueLine = ({ visibleOnHover, active }: Props): React$Element<any> => {
  return (
    <StyledBlueLineContainer visibleOnHover={visibleOnHover}>
      <StyledBlueLine active={active} visibleOnHover={visibleOnHover} />
    </StyledBlueLineContainer>
  )
}

export default BlueLine
